import * as ents from '@attain-apps/entities'

/**
 * Organization dimension ID
 */
export const DIMENSION_ID = ents.core.dms.models.Dimension.Id.from(
  ents.extra.quiver.resources.data.dimensions.organization.RESOURCE.payload,
)

/**
 * Division organization entity ID
 */
export const DIVISION_ENTITY_ID =
  ents.extra.quiver.resources.data.dimensions.organization.entities.division
    .MODEL_ID

/**
 * Department organization entity ID
 */
export const DEPARTMENT_ENTITY_ID =
  ents.extra.quiver.resources.data.dimensions.organization.entities.department
    .MODEL_ID
